<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowRightDropCircleOutline } from "@mdi/js";
export default {
  name: "MdiArrowRightDropCircleOutline",
  data() {
    return {
      svgPath: mdiArrowRightDropCircleOutline,
    };
  },
};
</script>
